document.addEventListener("DOMContentLoaded", () => {
     
    let viewAlternativeModal = document.querySelector(".view-alternatives--modal-container");

    if (viewAlternativeModal) {
      let viewAlternativeModalInner = viewAlternativeModal.querySelector(".inner");
      let viewAlternativeControls = document.querySelectorAll("[open-view-alternatives]");
      let viewAlternativeClose = viewAlternativeModal.querySelector(".close-button");
      let sectionName = "la-recommended-products";
      // let sectionName = "test-section";

      for (const control of viewAlternativeControls) {
    
          control.addEventListener("click", async (e) => {
            let handle = e.target.getAttribute("data-product-handle");
            e.preventDefault();
            fetch(`/products/${handle}?sections=${sectionName}`)
              .then((response) => {
                requestResponse = response;
                return response.json();
              })
              .then(data => {
                let html = data[`${sectionName}`];
                const htmlDocument = new DOMParser().parseFromString(html, "text/html");
                const recommendedProducts = htmlDocument.querySelector('.recommended-products');

                fetch(recommendedProducts.querySelector('.product-recommendations').dataset.url)
                .then((response) => {
                  requestResponse = response;
                  return response.text();
                })
                .then(data => {

                  viewAlternativeModalInner.innerHTML = data;
                })
                .then(result =>  {
                  const swiper_recommended = new swiper('.recommendations-slider', {
                    slidesPerView: 1.5,
                    spaceBetween: 8,
                    observer: true,
                    observeParents: true,
                    breakpoints: {
                      768: {
                        slidesPerView: 2.5
                      },
                      992: {
                        slidesPerView: 3
                      }
                    },
                    lazy: {
                      enabled: true,
                      checkInView: false,
                      loadOnTransitionStart: true,
                      loadPrevNext: true,
                      loadPrevNextAmount: 1
                    },
                    pagination: {
                      el: '.recommended-products-swiper-counter', // Element to display pagination
                      type: 'fraction', // Display fraction (e.g., 1/6)
                    },
                    navigation: {
                      nextEl: '.recommended-products-next',
                      prevEl: '.recommended-products-prev',
                    },
                  }); 
                  const next = document.querySelector('.recommended-products-next');
                  const prev = document.querySelector('.recommended-products-prev');

                  next.classList.add('active');
                  prev.classList.add('active');
                })
                .catch(function(error) {
                  console.log(error);
                });
              })
              
              .catch(function(error) {
                console.log(error);
              });
          });
        
      }

      viewAlternativeClose.addEventListener("click", () => {
        ViewAlternativeModal.classList.remove("active");
      });
    }
  
});
